import { buildChatThemeCssVars } from '../../theme/themeCssVars.js';

export const SIDEBAR_WIDTH = Object.freeze({ initial: 300, min: 280, max: 380, collapsed: 66, mainMin: 360 });

export function createStandaloneSurfaceStyle(themeTokens) {
  return {
    ...buildChatThemeCssVars(themeTokens),
    background: themeTokens.appBg,
    boxShadow: themeTokens.appShadow,
    display: 'grid',
    gridTemplateColumns: `${SIDEBAR_WIDTH.initial}px minmax(0, 1fr)`,
    gridTemplateRows: 'minmax(0, 1fr)',
    height: 'var(--flare-app-viewport-height, 100dvh)',
    minHeight: 0,
    overflow: 'hidden',
    position: 'relative',
  };
}
